import { AddIcon } from "@chakra-ui/icons";
import { Box, Button } from "@chakra-ui/react";
import React from "react";
import PropTypes from "prop-types";

export default function ModelsTriggerButton({ type, setIsModalOpen }) {
  const styles = {
    button: {
      size: "sm",
      mb: 4,
      colorScheme: "facebook",
    },
  };
  return (
    <Box style={{marginInline: 8}}>
      <Button
        {...styles.button}
        rightIcon={<AddIcon />}
        onClick={() => setIsModalOpen(true)}>
        Add {type}
      </Button>
    </Box>
  );
}

ModelsTriggerButton.propTypes = {
  type: PropTypes.string.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
};
